import { makeStyles } from "tss-react/mui";

export const useChipStackStyles = makeStyles({
  name: "ChipStack",
})((theme) => ({
  wrapper: {
    flexWrap: "wrap",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  chip: {
    margin: theme.spacing(0.7),
  },
}));
